import React, { FC } from 'react';
import { FormControl, FormGroup } from '@mui/material';
import { useWatch } from 'react-hook-form';
import { BlockPath } from '@/editor/PageEditor/CurrentBlockProvider';
import CheckboxInput from '@/components/forms/CheckboxInput';
import SwitchInput from '@/components/forms/SwitchInput';

export const SCHOOL_FILTERING_SORTING_FIELDS = [
  'gradeFilter',
  'subjectFilter',
  'ownerFilter',
  'queryFilter',
  'resourceTypeFilter',
  'sortBySelector',
  'orderSelector',
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ToggleSortingFilteringSettings: FC<{ tComp: any; blockPath: BlockPath }> = ({ tComp, blockPath }) => {
  const userFilteringSorting = useWatch({ name: `${blockPath}.enableFilters` });

  return (
    <FormControl>
      <div>
        <SwitchInput path={`${blockPath}.enableFilters`} label={tComp('DMBlock.AddFilteringSortingForUsers')} />
      </div>
      <FormGroup row>
        {SCHOOL_FILTERING_SORTING_FIELDS.map((field) => (
          <CheckboxInput
            key={field}
            path={`${blockPath}.${field}`}
            label={tComp(`DMBlock.EndUserFilteringSorting.${field}`)}
            fullWidth={false}
            disabled={!userFilteringSorting}
          />
        ))}
      </FormGroup>
    </FormControl>
  );
};

export default ToggleSortingFilteringSettings;
